import type { ReactElement } from 'react';

type Props = {
	isPrivate: boolean;
	children: (arg1: { isPrivate: boolean }) => ReactElement;
};

const PublicVsPrivateSwitchCell = (props: Props) => {
	const { isPrivate, children } = props;
	return children({ isPrivate });
};

export default PublicVsPrivateSwitchCell;
